// extracted by mini-css-extract-plugin
export default {"clearfix":"OngoingPaymentDetails_clearfix__daw4k","actionBar":"OngoingPaymentDetails_actionBar__S6-ua"};